import { mockComponent } from 'bloko/common/setupMockComponents';

import Textarea from 'bloko/blocks/textarea';

export default mockComponent('TextareaIcon', null, {
    // eslint-disable-next-line react/display-name
    innerDependence: ({ rows, cols, invalid, noresize, source, ...textareaProps }, ref) => {
        return <Textarea ref={ref} {...textareaProps} />;
    },
});
